import { useEffect, useState } from "react";
import { CustomSearchableDropdown } from "../components/CustomSearchableDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { getBrandsByYear } from "../services/VehicleDetails";
import { getLoctionOpenHours, post_CreateAppointment } from "../services/Appointment";
import { PleasewaitPopup } from "../components/PleasewaitPopup";
import useConfirm from "../hook/useConfirm";
import { getLocation } from "../services/Location";
import moment from "moment";
import { CustomDateField } from "../components/CustomDateField";
import { baseURL } from "../config/api";
import { TireSizeHelpPopup } from "../components/TireSizeHelpPopup";
import axios from "axios";
import { formatUSPhone, getUSPhoneDigits } from "../utils/phoneFormatter";

const currentYear = new Date().getFullYear();
const startYear = currentYear + 1;       // one year extra
const endYear = currentYear - 50;        // 50 years back

const yearOptions: any[] = [];
let yearCount = 0;
for (let year = startYear; year >= endYear; year--) {
    yearCount += 1;
    yearOptions.push({ value: yearCount, label: year.toString() });
}

export const BookService = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [service, setService] = useState<number>(0);
    const [isRequireTireCount, setisRequireTireCount] = useState<boolean>(false);
    const [serviceType, setServiceType] = useState<string>("");
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [brands, setBrands] = useState<any[]>([]);
    const [brandLabel, setBrandLabel] = useState<string>("");
    const [modelLabel, setModelLabel] = useState<string>("");
    const [vehicleYear, setVehicleYear] = useState<number | null>(null);
    const [brandId, setBrandId] = useState<number | null>(null);
    const [modelId, setModelId] = useState<number | null>(null);
    const [tireCount, setTireCount] = useState<number>(1);
    const [loadingBrand, setLoadingBrand] = useState(false);
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [locationOpenHour, setLocationOpenHour] = useState<any[]>([]);
    const [locationAddress, setLoactionAddress] = useState<string>("");
    const [locationLink, setLoactionLink] = useState<string>("");
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    const [selectedTime, setSelectedTime] = useState<string>(moment().format('HH:mm'));
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [additionalInfo, setAdditionalInfo] = useState<string>("");
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);
    const [trimId, setTrimId] = useState<any>(null);
    const [trimLabel, setTrimLabel] = useState<string>("");
    //model
    const [modelLoadingMore, setModelLoadingMore] = useState(false);
    const [modelPage, setModelPage] = useState(1);
    const [modelHasMore, setModelHasMore] = useState(true);
    const [modelInitialLoading, setModelInitialLoading] = useState(false);
    const [modelResults, setModelResults] = useState<any[]>([]);
    const [modelSearchQuery, setModelSearchQuery] = useState<string>("");
    //trim
    const [trimLoadingMore, setTrimLoadingMore] = useState(false);
    const [trimPage, setTrimPage] = useState(1);
    const [trimHasMore, setTrimHasMore] = useState(true);
    const [trimInitialLoading, setTrimInitialLoading] = useState(false);
    const [trimResults, setTrimResults] = useState<any[]>([]);
    const [trimSearchQuery, setTrimSearchQuery] = useState<string>("");
    const [tireSizeId, setTireSizeId] = useState<any>(null);
    //Tire Size width
    const [tireWidthLabel, setTireWidthLabel] = useState<string>("");
    const [tireWidthLoadingMore, setTireWidthLoadingMore] = useState(false);
    const [tireWidthPage, setTireWidthPage] = useState(1);
    const [tireWidthHasMore, setTireWidthHasMore] = useState(true);
    const [tireWidthInitialLoading, setTireWidthInitialLoading] = useState(false);
    const [tireWidthResults, setTireWidthResults] = useState<any[]>([]);
    const [tireWidthSearchQuery, setTireWidthSearchQuery] = useState<string>("");
    //Tire Size ratio
    const [tireRatioLabel, setTireRatioLabel] = useState<string>("");
    const [tireRatioLoadingMore, setTireRatioLoadingMore] = useState(false);
    const [tireRatioPage, setTireRatioPage] = useState(1);
    const [tireRatioHasMore, setTireRatioHasMore] = useState(true);
    const [tireRatioInitialLoading, setTireRatioInitialLoading] = useState(false);
    const [tireRatioResults, setTireRatioResults] = useState<any[]>([]);
    const [tireRatioSearchQuery, setTireRatioSearchQuery] = useState<string>("");

    //Tire Size diameter
    const [tireDiameterLabel, setTireDiameterLabel] = useState<string>("");
    const [tireDiameterLoadingMore, setTireDiameterLoadingMore] = useState(false);
    const [tireDiameterPage, setTireDiameterPage] = useState(1);
    const [tireDiameterHasMore, setTireDiameterHasMore] = useState(true);
    const [tireDiameterInitialLoading, setTireDiameterInitialLoading] = useState(false);
    const [tireDiameterResults, setTireDiameterResults] = useState<any[]>([]);
    const [tireDiameterSearchQuery, setTireDiameterSearchQuery] = useState<string>("");

    const [rearTireSizeId, setRearTireSizeId] = useState<any>(null);
    //Rear Tire Width
    const [rearTireWidthLabel, setRearTireWidthLabel] = useState<string>("");
    const [rearTireWidthLoadingMore, setRearTireWidthLoadingMore] = useState(false);
    const [rearTireWidthPage, setRearTireWidthPage] = useState(1);
    const [rearTireWidthHasMore, setRearTireWidthHasMore] = useState(true);
    const [rearTireWidthInitialLoading, setRearTireWidthInitialLoading] = useState(false);
    const [rearTireWidthResults, setRearTireWidthResults] = useState<any[]>([]);
    const [rearTireWidthSearchQuery, setRearTireWidthSearchQuery] = useState<string>("");

    //Rear Tire Ratio
    const [rearTireRatioLabel, setRearTireRatioLabel] = useState<string>("");
    const [rearTireRatioLoadingMore, setRearTireRatioLoadingMore] = useState(false);
    const [rearTireRatioPage, setRearTireRatioPage] = useState(1);
    const [rearTireRatioHasMore, setRearTireRatioHasMore] = useState(true);
    const [rearTireRatioInitialLoading, setRearTireRatioInitialLoading] = useState(false);
    const [rearTireRatioResults, setRearTireRatioResults] = useState<any[]>([]);
    const [rearTireRatioSearchQuery, setRearTireRatioSearchQuery] = useState<string>("");

    //Rear Tire Diameter
    const [rearTireDiameterLabel, setRearTireDiameterLabel] = useState<string>("");
    const [rearTireDiameterLoadingMore, setRearTireDiameterLoadingMore] = useState(false);
    const [rearTireDiameterPage, setRearTireDiameterPage] = useState(1);
    const [rearTireDiameterHasMore, setRearTireDiameterHasMore] = useState(true);
    const [rearTireDiameterInitialLoading, setRearTireDiameterInitialLoading] = useState(false);
    const [rearTireDiameterResults, setRearTireDiameterResults] = useState<any[]>([]);
    const [rearTireDiameterSearchQuery, setRearTireDiameterSearchQuery] = useState<string>("");

    const [isCantFindIt, setIsCantFindIt] = useState<boolean>(false);
    const [showTireSizeHelpPopup, setShowTireSizeHelpPopup] = useState<boolean>(false);
    const [isCommercial, setIsCommercial] = useState<boolean>(false);
    const [isRearTireSize, setIsRearTireSize] = useState<boolean>(false);
    const [isRequestedTireSize, setIsRequestedTireSize] = useState<boolean>(false);

    const [requestedTireWidth, setRequestedTireWidth] = useState<string>("");
    const [requestedTireRatio, setRequestedTireRatio] = useState<string>("");
    const [requestedTireDiameter, setRequestedTireDiameter] = useState<string>("");

    const [blockDaysCheckWarning, setBlockDaysCheckWarning] = useState<string | null>(null);

    useEffect(() => {
        if (!location.state?.service) {
            navigate("/", { replace: true });
            return;
        }
        setService(location.state?.service);
        setisRequireTireCount(location.state?.requiresTireCount);
        setServiceType(location.state?.serviceType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName,
                        address: `${loc?.street}, ${loc?.city}, ${loc?.state} ${loc?.zipCode}, ${loc?.country}`,
                        locationlink: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${loc?.street}, ${loc?.city}, ${loc?.state} ${loc?.zipCode}`)}`
                    }
                }))
                setLocationId(data[0]?.id);
                setLoactionAddress(`${data[0]?.street}, ${data[0]?.city}, ${data[0]?.state} ${data[0]?.zipCode}, ${data[0]?.country}`);
                setLoactionLink(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${data[0]?.street}, ${data[0]?.city}, ${data[0]?.state} ${data[0]?.zipCode}`)}`)
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        if (locationId > 0) {
            getLoctionOpenHours(locationId)
                .then(data => {
                    setLocationOpenHour(data?.filter((item: any) => new Date(item.startDate) <= new Date() && new Date(item.endDate) >= new Date()));
                })
                .catch((error) => {
                    setLocationOpenHour([]);
                    console.error(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId]);


    useEffect(() => {
        if (vehicleYear) {
            setLoadingBrand(true);
            getBrandsByYear()
                .then((data) => {
                    const brandsOptions = data?.map((item: any) => {
                        return {
                            value: item?.makeID,
                            label: item?.name
                        }
                    })
                    setBrands(brandsOptions);
                    setLoadingBrand(false);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        else {
            setBrandId(null);
            setBrandLabel("");
            setBrands([]);
        }
    }, [vehicleYear])

    useEffect(() => {
        setModelPage(1)
        setModelHasMore(true);
        setModelResults([]);
        setModelSearchQuery("");
        setModelId(null);
        setModelLabel("");
    }, [brandId])

    useEffect(() => {
        setTrimPage(1)
        setTrimHasMore(true);
        setTrimResults([]);
        setTrimSearchQuery("");
        setTrimId(null);
        setTrimLabel("");
    }, [modelId])

    useEffect(() => {
        setTireSizeId(null);
    }, [trimId])

    useEffect(() => {
        setVehicleYear(null);
        setBrandId(null);
        setBrandLabel("");
        setModelId(null);
        setModelLabel("");
        setBrands([]);
        setModelResults([]);
        setTrimId(null);
        setTrimLabel("");
        setTrimResults([]);
        setIsRearTireSize(false)
        setIsCommercial(false);

        setTireSizeId(null);
        setIsRearTireSize(false)
        setTireWidthPage(1)
        setTireWidthHasMore(true);
        setTireWidthResults([]);
        setTireWidthSearchQuery("");
        setTireWidthLabel("");

        setTireRatioPage(1)
        setTireRatioHasMore(true);
        setTireRatioResults([]);
        setTireRatioSearchQuery("");
        setTireRatioLabel("");

        setTireDiameterPage(1)
        setTireDiameterHasMore(true);
        setTireDiameterResults([]);
        setTireDiameterSearchQuery("");
        setTireDiameterLabel("");
    }, [isCantFindIt])

    useEffect(() => {
        if (!tireSizeId) {
            setIsRearTireSize(false)
            setIsCommercial(false);

            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }
    }, [tireSizeId])

    useEffect(() => {
        if ((!tireWidthLabel.length && !tireWidthSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setTireWidthPage(1)
            setTireWidthHasMore(true);
            setTireWidthResults([]);
            setTireWidthSearchQuery("");
            setTireWidthLabel("");

            setTireSizeId(null)
            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tireWidthLabel, tireWidthSearchQuery, modelId])


    useEffect(() => {
        if ((!tireRatioLabel.length && !tireRatioSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");

            setTireSizeId(null)
            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tireRatioLabel, tireRatioSearchQuery, modelId])

    useEffect(() => {
        if ((!rearTireWidthLabel.length && !rearTireWidthSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setRearTireWidthPage(1)
            setRearTireWidthHasMore(true);
            setRearTireWidthResults([]);
            setRearTireWidthSearchQuery("");
            setRearTireWidthLabel("");

            setRearTireSizeId(null)
            setRearTireRatioPage(1)
            setRearTireRatioHasMore(true);
            setRearTireRatioResults([]);
            setRearTireRatioSearchQuery("");
            setRearTireRatioLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rearTireWidthLabel, rearTireWidthSearchQuery, modelId])

    useEffect(() => {
        if ((!rearTireRatioLabel.length && !rearTireRatioSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setRearTireRatioPage(1)
            setRearTireRatioHasMore(true);
            setRearTireRatioResults([]);
            setRearTireRatioSearchQuery("");
            setRearTireRatioLabel("");

            setRearTireSizeId(null)
            setRearTireDiameterPage(1)
            setRearTireDiameterHasMore(true);
            setRearTireDiameterResults([]);
            setRearTireDiameterSearchQuery("");
            setRearTireDiameterLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rearTireRatioLabel, rearTireRatioSearchQuery, modelId])

    useEffect(() => {
        setRearTireSizeId(null);
        setRearTireWidthPage(1)
        setRearTireWidthHasMore(true);
        setRearTireWidthResults([]);
        setRearTireWidthSearchQuery("");
        setRearTireWidthLabel("");

        setRearTireRatioPage(1)
        setRearTireRatioHasMore(true);
        setRearTireRatioResults([]);
        setRearTireRatioSearchQuery("");
        setRearTireRatioLabel("");

        setRearTireDiameterPage(1)
        setRearTireDiameterHasMore(true);
        setRearTireDiameterResults([]);
        setRearTireDiameterSearchQuery("");
        setRearTireDiameterLabel("");

    }, [isRearTireSize])


    useEffect(() => {
        if (!rearTireSizeId) {
            setRearTireDiameterPage(1)
            setRearTireDiameterHasMore(true);
            setRearTireDiameterResults([]);
            setRearTireDiameterSearchQuery("");
            setRearTireDiameterLabel("");
        }
    }, [rearTireSizeId])


    useEffect(() => {
        setRequestedTireWidth("");
        setRequestedTireRatio("");
        setRequestedTireDiameter("");

    }, [isRequestedTireSize])


    useEffect(() => {
        const startDateTime = moment(`${selectedDate}T${selectedTime}`).format('YYYY-MM-DDTHH:mm');
        const endDateTime = moment(`${selectedDate}T${selectedTime}`).format('YYYY-MM-DDTHH:mm');
        setShowPleasewait(true);
        axios.get(`${baseURL}blockedDays/GetBlockedDaysByStartDateAndEndDate/${startDateTime},${endDateTime}`)
            .then((res) => {
                setShowPleasewait(false);
                if (res.data?.length > 0) {
                    if (res.data[0]?.isAllDay) {
                        setBlockDaysCheckWarning(`We are closed on ${moment(selectedDate).format("MM/DD/YYYY")} please choose different date.`)
                    }
                    else {
                        setBlockDaysCheckWarning(`We are closed on ${moment(selectedDate).format("MM/DD/YYYY")} between ${moment(res.data[0]?.startTime, "HH:mm").format("hh:mm A")} to ${moment(res.data[0]?.endTIme, "HH:mm").format("hh:mm A")}  please choose different time.`)
                    }
                }
                else {
                    let openHourWarning = "";
                    if (locationOpenHour?.length > 0) {
                        switch (new Date(selectedDate.replaceAll("-", "/")).getDay()) {
                            case 0:
                                if (locationOpenHour[0].isSundayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].sundayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].sundayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Sunday from " +
                                            moment(locationOpenHour[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Sunday";
                                }
                                break;
                            case 1:
                                if (locationOpenHour[0].isMondayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].mondayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].mondayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Monday from " +
                                            moment(locationOpenHour[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Monday";
                                }
                                break;
                            case 2:
                                if (locationOpenHour[0].isTuesdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].tuesdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].tuesdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Tuesday from " +
                                            moment(locationOpenHour[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Tuesday";
                                }
                                break;
                            case 3:
                                if (locationOpenHour[0].isWednesdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].wednesdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].wednesdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Wednesday from " +
                                            moment(locationOpenHour[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Wednesday";
                                }
                                break;
                            case 4:
                                if (locationOpenHour[0].isThursdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].thursdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].thursdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Thursday from " +
                                            moment(locationOpenHour[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Thursday";
                                }
                                break;
                            case 5:
                                if (locationOpenHour[0].isFridayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].fridayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].fridayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Friday from " +
                                            moment(locationOpenHour[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Friday";
                                }
                                break;
                            case 6:
                                if (locationOpenHour[0].isSaturdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].saturdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].saturdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Saturday from " +
                                            moment(locationOpenHour[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Saturday";
                                }
                                break;
                        }
                    }
                    if (openHourWarning === "") {
                        setBlockDaysCheckWarning("");
                    }
                    else {
                        setBlockDaysCheckWarning(openHourWarning);
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate, selectedTime, locationOpenHour])

    const modelFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!brandId) return;
        if (modelLoadingMore) return;
        if (!modelHasMore && !isFresh) return;
        if (isFresh) {
            setModelInitialLoading(true);
            setModelHasMore(true);
        } else {
            setModelLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}models/GetModelsPagingByMakeIdAndSearchWithModelName?modelName=${modelSearchQuery.trim()
            }&page=${pageToLoad}&size=${pageSize}&makeId=${brandId}`
            : `${baseURL}models/GetModelsPagingByMakeId/${pageToLoad},${pageSize},${brandId}`;

        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.models?.map((item: any) => {
                return {
                    value: item?.modelID,
                    label: item?.name
                }
            }) || [];

            setModelResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setModelHasMore(list.length === pageSize);
            setModelPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setModelLoadingMore(false);
            setModelInitialLoading(false);
        }
    };

    const trimFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!modelId) return;
        if (trimLoadingMore) return;
        if (!trimHasMore && !isFresh) return;
        if (isFresh) {
            setTrimInitialLoading(true);
            setTrimHasMore(true);
        } else {
            setTrimLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}vehicleTrims/GetVehicleTrimsPagingByModelIdAndSearchWithTrimName?trimName=${trimSearchQuery.trim()
            }&page=${pageToLoad}&size=${pageSize}&modelId=${modelId}`
            : `${baseURL}vehicleTrims/GetVehicleTrimsPagingByModelId/${pageToLoad},${pageSize},${modelId}`;


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.vehicleTrims?.map((item: any) => {
                return {
                    value: item?.vehicleTrimID,
                    label: item?.trimName
                }
            }) || [];

            setTrimResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTrimHasMore(list.length === pageSize);
            setTrimPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTrimLoadingMore(false);
            setTrimInitialLoading(false);
        }

    };

    const tireWidthFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!isCantFindIt && !modelId) return;
        if (tireWidthLoadingMore) return;
        if (!tireWidthHasMore && !isFresh) return;
        if (isFresh) {
            setTireWidthInitialLoading(true);
            setTireWidthHasMore(true);
        } else {
            setTireWidthLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&position=${false}` :

                    !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&position=${false}`
                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&position=${false}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.metricWidth)
                }
            }) || [];

            setTireWidthResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireWidthHasMore(list.length === pageSize);
            setTireWidthPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireWidthLoadingMore(false);
            setTireWidthInitialLoading(false);
        }

    };


    const tireRatioFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!tireWidthLabel) return;
        if (tireRatioLoadingMore) return;
        if (!tireRatioHasMore && !isFresh) return;
        if (isFresh) {
            setTireRatioInitialLoading(true);
            setTireRatioHasMore(true);
        } else {
            setTireRatioLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&position=${false}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&position=${false}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&position=${false}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.aspectRatio)
                }
            }) || [];

            setTireRatioResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireRatioHasMore(list.length === pageSize);
            setTireRatioPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireRatioLoadingMore(false);
            setTireRatioInitialLoading(false);
        }


    };


    const tireDiameterFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!tireRatioLabel || !tireWidthLabel) return;
        if (tireDiameterLoadingMore) return;
        if (!tireDiameterHasMore && !isFresh) return;
        if (isFresh) {
            setTireDiameterInitialLoading(true);
            setTireDiameterHasMore(true);
        } else {
            setTireDiameterLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`



        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.diameter)
                }
            }) || [];

            setTireDiameterResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireDiameterHasMore(list.length === pageSize);
            setTireDiameterPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireDiameterLoadingMore(false);
            setTireDiameterInitialLoading(false);
        }

    };


    const rearTireWidthFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {

        if (rearTireWidthLoadingMore) return;
        if (!rearTireWidthHasMore && !isFresh) return;
        if (isFresh) {
            setRearTireWidthInitialLoading(true);
            setRearTireWidthHasMore(true);
        } else {
            setRearTireWidthLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${true}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${true}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&position=${true}` :

                    !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&position=${true}`
                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthSearchQuery.trim()}&position=${true}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&position=${true}`




        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.metricWidth)
                }
            }) || [];

            setRearTireWidthResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setRearTireWidthHasMore(list.length === pageSize);
            setRearTireWidthPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setRearTireWidthLoadingMore(false);
            setRearTireWidthInitialLoading(false);
        }

    };


    const rearTireRatioFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!rearTireWidthLabel) return;
        if (rearTireRatioLoadingMore) return;
        if (!rearTireRatioHasMore && !isFresh) return;
        if (isFresh) {
            setRearTireRatioInitialLoading(true);
            setRearTireRatioHasMore(true);
        } else {
            setRearTireRatioLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${true}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${true}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&position=${true}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&position=${true}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${true}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&position=${true}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.aspectRatio)
                }
            }) || [];

            setRearTireRatioResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setRearTireRatioHasMore(list.length === pageSize);
            setRearTireRatioPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setRearTireRatioLoadingMore(false);
            setRearTireRatioInitialLoading(false);
        }

    };


    const rearTireDiameterFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!rearTireRatioLabel || !rearTireWidthLabel) return;
        if (rearTireDiameterLoadingMore) return;
        if (!rearTireDiameterHasMore && !isFresh) return;
        if (isFresh) {
            setRearTireDiameterInitialLoading(true);
            setRearTireDiameterHasMore(true);
        } else {
            setRearTireDiameterLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${true}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${true}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${true}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${true}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${true}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${true}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.diameter)
                }
            }) || [];

            setRearTireDiameterResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setRearTireDiameterHasMore(list.length === pageSize);
            setRearTireDiameterPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setRearTireDiameterLoadingMore(false);
            setRearTireDiameterInitialLoading(false);
        }

    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setEmail(value);
        const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/gm.test(value);
        e.target.setCustomValidity(isValid ? "" : "Please enter a valid email");
    };



    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isCantFindIt && (!vehicleYear || !brandId || !modelId) && (serviceType === "Tire" || serviceType === "Wheel")) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select all vehicles details.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }

        if (!isCantFindIt && (!vehicleYear || !brandId || !modelId) && serviceType !== "Tire" && serviceType !== "Wheel") {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select all vehicles details.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && !isCantFindIt && vehicleYear && brandId && modelId && !isRearTireSize && !tireSizeId && !isRequestedTireSize) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select a tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }

        if ((serviceType === "Tire" || serviceType === "Wheel") && !isCantFindIt && vehicleYear && brandId && modelId && isRearTireSize && !rearTireSizeId && !isRequestedTireSize) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select a rear tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && isCantFindIt && !isRearTireSize && !isRequestedTireSize && !tireSizeId) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select a tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && isCantFindIt && isRearTireSize && !isRequestedTireSize && !rearTireSizeId) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select rear tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && !isCantFindIt && !isRearTireSize && !isRequestedTireSize && !tireSizeId) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select a tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && !isCantFindIt && isRearTireSize && !isRequestedTireSize && !rearTireSizeId) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select rear tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && isRequestedTireSize && (!requestedTireWidth.length || !requestedTireRatio.length || !requestedTireDiameter.length)) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please enter valid requested tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }



        if ((serviceType === "Tire" || serviceType === "Wheel") && !isRearTireSize && tireSizeId && !isRequestedTireSize && (!tireWidthLabel.length || !tireRatioLabel.length || !tireDiameterLabel.length)) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select valid tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && isRearTireSize && tireSizeId && rearTireSizeId && !isRequestedTireSize && (!tireWidthLabel.length || !tireRatioLabel.length || !tireDiameterLabel.length || !rearTireWidthLabel.length || !rearTireRatioLabel.length || !rearTireDiameterLabel.length)) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select valid front and rear tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }


        if ((serviceType === "Tire" || serviceType === "Wheel") && isRearTireSize && !tireSizeId && rearTireSizeId && !isRequestedTireSize && (!rearTireWidthLabel.length || !rearTireRatioLabel.length || !rearTireDiameterLabel.length)) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select valid rear tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }



        if (!selectedDate || !selectedTime) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select date and time.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }

        const startDateTime = moment(`${selectedDate}T${selectedTime}`).format('YYYY-MM-DDTHH:mm');
        const endDateTime = moment(`${selectedDate}T${selectedTime}`).format('YYYY-MM-DDTHH:mm');
        setShowPleasewait(true);
        axios.get(`${baseURL}blockedDays/GetBlockedDaysByStartDateAndEndDate/${startDateTime},${endDateTime}`)
            .then((res) => {
                setShowPleasewait(false);
                if (res.data.length > 0) {
                    if (res.data[0]?.isAllDay) {
                        setConfirmPopup(true);
                        setConfirmData({
                            title: `We are closed on ${moment(selectedDate).format("MM/DD/YYYY")} please choose different date.`,
                            confirmBtn: "Ok",
                            isConfirm: (callback: any) => {
                                callback();
                            }
                        })
                        return;
                    }
                    else {
                        setConfirmPopup(true);
                        setConfirmData({
                            title: `We are closed on ${moment(selectedDate).format("MM/DD/YYYY")} between ${moment(res.data[0]?.startTime, "HH:mm").format("hh:mm A")} to ${moment(res.data[0]?.endTIme, "HH:mm").format("hh:mm A")}  please choose different time.`,
                            confirmBtn: "Ok",
                            isConfirm: (callback: any) => {
                                callback();
                            }
                        })
                        return;
                    }
                }
                else {
                    let openHourWarning = "";
                    if (locationOpenHour?.length > 0) {
                        switch (new Date(selectedDate.replaceAll("-", "/")).getDay()) {
                            case 0:
                                if (locationOpenHour[0].isSundayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].sundayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].sundayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Sunday from " +
                                            moment(locationOpenHour[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Sunday";
                                }
                                break;
                            case 1:
                                if (locationOpenHour[0].isMondayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].mondayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].mondayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Monday from " +
                                            moment(locationOpenHour[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Monday";
                                }
                                break;
                            case 2:
                                if (locationOpenHour[0].isTuesdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].tuesdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].tuesdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Tuesday from " +
                                            moment(locationOpenHour[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Tuesday";
                                }
                                break;
                            case 3:
                                if (locationOpenHour[0].isWednesdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].wednesdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].wednesdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Wednesday from " +
                                            moment(locationOpenHour[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Wednesday";
                                }
                                break;
                            case 4:
                                if (locationOpenHour[0].isThursdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].thursdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].thursdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Thursday from " +
                                            moment(locationOpenHour[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Thursday";
                                }
                                break;
                            case 5:
                                if (locationOpenHour[0].isFridayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].fridayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].fridayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Friday from " +
                                            moment(locationOpenHour[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Friday";
                                }
                                break;
                            case 6:
                                if (locationOpenHour[0].isSaturdayOpen) {
                                    openHourWarning = ""
                                    if (
                                        locationOpenHour[0].saturdayOpenTime <=
                                        selectedTime &&
                                        locationOpenHour[0].saturdayCloseTime >=
                                        selectedTime
                                    ) {
                                        openHourWarning = ""
                                    }
                                    else {
                                        openHourWarning = "We are open on Saturday from " +
                                            moment(locationOpenHour[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                            " to " +
                                            moment(locationOpenHour[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                    }
                                } else {
                                    openHourWarning = "We are closed on Saturday";
                                }
                                break;
                        }
                    }
                    if (openHourWarning === "") {
                        if (service) {
                            setShowPleasewait(true);
                            post_CreateAppointment({
                                appointmentDate: selectedDate,
                                timeSlot: selectedTime,
                                tireCount: isRequireTireCount ? tireCount : 0,
                                serviceID: service,
                                locationId: locationId,
                                customer: {
                                    firstName: firstName,
                                    lastName: lastName,
                                    phone: phoneNumber,
                                    email: email,
                                    address: "",
                                    city: "",
                                    state: "",
                                    zipCode: "",
                                    additionalInformation: additionalInfo
                                },
                                vehicle: {
                                    makeID: brandId,
                                    modelID: modelId,
                                    vehicleYear: vehicleYear ? Number(vehicleYear) : null,
                                    vin: "",
                                    tireSize: "",
                                    wheelSize: "",
                                    vehicleTrimID: trimId > 0 ? trimId : null,
                                    tireFitmentID: !isRequestedTireSize ? tireSizeId : null,
                                    rearTireFitmentID: !isRequestedTireSize ? rearTireSizeId : null,
                                    isCommercial,
                                    isRequestForTireSize: isRequestedTireSize,
                                    metricWidth: requestedTireWidth,
                                    aspectRatio: requestedTireRatio,
                                    diameter: requestedTireDiameter
                                }
                            })
                                .then((data) => {
                                    setShowPleasewait(false);
                                    navigate("/booking-confirm", {
                                        state: {
                                            id: data,
                                            serviceType
                                        },
                                    })
                                })
                                .catch((error) => {
                                    console.error(error);
                                })
                        }
                    }
                    else {
                        setConfirmPopup(true);
                        setConfirmData({
                            title: openHourWarning,
                            confirmBtn: "Ok",
                            isConfirm: (callback: any) => {
                                callback();
                            }
                        })
                        return;
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    return (
        <>
            <div className="w-full">
                <div className="w-full bg-gray-100 min-h-screen pt-20 pb-4 px-10 flex justify-center">
                    <div className="space-y-6 bg-white rounded-xl p-6 shadow-lg max-w-xl w-full">
                        {
                            locationOptions?.length > 1 && (
                                <div className={`flex items-end gap-3.5 justify-between pb-2 border-b`}>
                                    <div>
                                        <label className="text-sm font-medium text-gray-700 block mb-1">
                                            Location
                                        </label>
                                        <select
                                            value={locationId}
                                            onChange={(e) => {
                                                setLocationId(Number(e.target.value))
                                                setLoactionAddress(locationOptions?.filter((loc: any) => loc?.value === Number(e.target.value))[0]?.address)
                                                setLoactionLink(locationOptions?.filter((loc: any) => loc?.value === Number(e.target.value))[0]?.locationlink)
                                            }}
                                            className="w-[200px] border border-gray-300 rounded-xl p-3 text-sm outline-none focus:border-primary bg-white"
                                        >
                                            {locationOptions.map((loc: any, index: number) => (
                                                <option key={index} value={loc?.value}>
                                                    {loc?.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>


                                    <a
                                        href={locationLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-xs text-primary inline-block underline hover:cursor-pointer"
                                    >
                                        <span>{locationAddress}</span>
                                    </a>


                                </div>
                            )
                        }

                        {
                            !isCantFindIt && (
                                <>
                                    <div className={`flex items-center justify-between`}>
                                        <h2 className="text-lg font-semibold text-gray-800">
                                            Vehicle Details
                                        </h2>

                                        {
                                            (!isCantFindIt && (serviceType === "Tire" || serviceType === "Wheel")) && (
                                                <span onClick={() => {
                                                    setIsCantFindIt(true);
                                                    setVehicleYear(null);
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">Book with tire size</span>
                                            )
                                        }

                                    </div>
                                    <div className="grid grid-cols-3 gap-3 border-b pb-4 relative">
                                        <CustomSearchableDropdown
                                            label="Year"
                                            options={yearOptions}
                                            value={vehicleYear}
                                            setValue={setVehicleYear}
                                            onChange={setVehicleYear}
                                            placeholder="Search Year"

                                        />

                                        <CustomSearchableDropdown
                                            label="Make"
                                            options={brands}
                                            value={brandId}
                                            setValue={setBrandId}
                                            selectedOptionLabel={brandLabel}
                                            setSelectedOptionLabel={setBrandLabel}
                                            onChange={(value: number, label?: string) => {
                                                setBrandId(value);
                                                if (label)
                                                    setBrandLabel(label)
                                            }}
                                            placeholder="Search Make"
                                            loading={loadingBrand}
                                            setIsCantFindIt={setIsCantFindIt}
                                            serviceType={serviceType}
                                        />

                                        <CustomSearchableDropdown
                                            label="Model"
                                            value={modelId}
                                            setValue={setModelId}
                                            selectedOptionLabel={modelLabel}
                                            setSelectedOptionLabel={setModelLabel}
                                            placeholder="Search Model"
                                            onDemandData={true}
                                            setResults={setModelResults}
                                            results={modelResults}
                                            fetchData={modelFetchData}
                                            setSearchQuery={setModelSearchQuery}
                                            searchQuery={modelSearchQuery}
                                            initialLoading={modelInitialLoading}
                                            loadingMore={modelLoadingMore}
                                            page={modelPage}
                                            setPage={setModelPage}
                                            hasMore={modelHasMore}
                                            setHasMore={setModelHasMore}
                                            setIsCantFindIt={setIsCantFindIt}
                                            serviceType={serviceType}
                                        />
                                    </div>
                                </>
                            )
                        }

                        {
                            (modelId && modelId > 0 && !isCantFindIt && (serviceType === "Tire" || serviceType === "Wheel")) && (
                                <>
                                    <h2 className="text-lg font-semibold text-gray-800">
                                        Select Trim
                                    </h2>
                                    <div className="border-b pb-4 relative">
                                        <CustomSearchableDropdown
                                            label="Trim (Optional)"
                                            value={trimId}
                                            setValue={setTrimId}
                                            selectedOptionLabel={trimLabel}
                                            setSelectedOptionLabel={setTrimLabel}
                                            placeholder="Search Trim"
                                            onDemandData={true}
                                            setResults={setTrimResults}
                                            results={trimResults}
                                            fetchData={trimFetchData}
                                            setSearchQuery={setTrimSearchQuery}
                                            searchQuery={trimSearchQuery}
                                            initialLoading={trimInitialLoading}
                                            loadingMore={trimLoadingMore}
                                            page={trimPage}
                                            setPage={setTrimPage}
                                            hasMore={trimHasMore}
                                            setHasMore={setTrimHasMore}
                                            setIsCantFindIt={setIsCantFindIt}
                                        />
                                    </div>

                                </>
                            )
                        }

                        {
                            (((modelId !== null && modelId > 0) || isCantFindIt) && !isRequestedTireSize && (serviceType === "Tire" || serviceType === "Wheel")) && (
                                <>
                                    <div className={`flex items-center justify-between`}>
                                        <h2 className="text-lg font-semibold text-gray-800">
                                            Select {isRearTireSize ? "Front" : ""} Tire Size
                                        </h2>

                                        {
                                            isCantFindIt && (
                                                <span onClick={() => {
                                                    setIsCantFindIt(false);
                                                    setVehicleYear(null);
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">Book with vehicle details</span>
                                            )
                                        }

                                    </div>

                                    <div className="border-b pb-4 relative">
                                        <p className="text-center text-sm font-semibold">
                                            Find your tire size inside of vehicle's driver front door jamb
                                        </p>
                                        <div className="flex items-center justify-center">
                                            <img
                                                src="/images/tiresizehelp2.png"
                                                alt="Tire size example"
                                                className="rounded w-[320px]"
                                            />
                                        </div>
                                        <div className="grid grid-cols-3 gap-3">
                                            <CustomSearchableDropdown
                                                label="Width"
                                                selectedOptionLabel={tireWidthLabel}
                                                setSelectedOptionLabel={setTireWidthLabel}
                                                placeholder="Search Width"
                                                onDemandData={true}
                                                setResults={setTireWidthResults}
                                                results={tireWidthResults}
                                                fetchData={tireWidthFetchData}
                                                setSearchQuery={setTireWidthSearchQuery}
                                                searchQuery={tireWidthSearchQuery}
                                                initialLoading={tireWidthInitialLoading}
                                                loadingMore={tireWidthLoadingMore}
                                                page={tireWidthPage}
                                                setPage={setTireWidthPage}
                                                hasMore={tireWidthHasMore}
                                                setHasMore={setTireWidthHasMore}
                                            />

                                            <CustomSearchableDropdown
                                                label="Ratio"
                                                selectedOptionLabel={tireRatioLabel}
                                                setSelectedOptionLabel={setTireRatioLabel}
                                                placeholder="Search Ratio"
                                                onDemandData={true}
                                                setResults={setTireRatioResults}
                                                results={tireRatioResults}
                                                fetchData={tireRatioFetchData}
                                                setSearchQuery={setTireRatioSearchQuery}
                                                searchQuery={tireRatioSearchQuery}
                                                initialLoading={tireRatioInitialLoading}
                                                loadingMore={tireRatioLoadingMore}
                                                page={tireRatioPage}
                                                setPage={setTireRatioPage}
                                                hasMore={tireRatioHasMore}
                                                setHasMore={setTireRatioHasMore}
                                            />

                                            <CustomSearchableDropdown
                                                label="Diameter"
                                                value={tireSizeId}
                                                setValue={setTireSizeId}
                                                selectedOptionLabel={tireDiameterLabel}
                                                setSelectedOptionLabel={setTireDiameterLabel}
                                                placeholder="Search Diameter"
                                                onDemandData={true}
                                                setResults={setTireDiameterResults}
                                                results={tireDiameterResults}
                                                fetchData={tireDiameterFetchData}
                                                setSearchQuery={setTireDiameterSearchQuery}
                                                searchQuery={tireDiameterSearchQuery}
                                                initialLoading={tireDiameterInitialLoading}
                                                loadingMore={tireDiameterLoadingMore}
                                                page={tireDiameterPage}
                                                setPage={setTireDiameterPage}
                                                hasMore={tireDiameterHasMore}
                                                setHasMore={setTireDiameterHasMore}
                                            />
                                        </div>

                                        <div className={`flex items-center justify-between mt-2`}>
                                            {
                                                !isRearTireSize && (
                                                    <span onClick={() => {
                                                        setIsRearTireSize(true)
                                                    }} className="text-xs underline hover:cursor-pointer text-blue-600">+ add a rear tire size</span>
                                                )
                                            }

                                            {
                                                !isRequestedTireSize && (
                                                    <span onClick={() => {
                                                        setIsRequestedTireSize(true)
                                                    }} className="text-xs underline hover:cursor-pointer text-blue-600">still can't find my tire size</span>
                                                )
                                            }

                                            <span onClick={() => {
                                                setShowTireSizeHelpPopup(true)
                                            }} className="text-xs underline hover:cursor-pointer text-blue-600">Need help finding tire size?</span>
                                        </div>
                                    </div>

                                </>
                            )
                        }

                        {
                            (isRearTireSize && ((modelId !== null && modelId > 0) || isCantFindIt) && !isRequestedTireSize && (serviceType === "Tire" || serviceType === "Wheel")) && (
                                <>
                                    <div className={`flex items-center`}>
                                        <h2 className="text-lg font-semibold text-gray-800">
                                            Select Rear Tire Size
                                        </h2>
                                    </div>

                                    <div className="border-b pb-4 relative">
                                        <div className="grid grid-cols-3 gap-3 pb-4 relative">
                                            <CustomSearchableDropdown
                                                label="Width"
                                                selectedOptionLabel={rearTireWidthLabel}
                                                setSelectedOptionLabel={setRearTireWidthLabel}
                                                placeholder="Search Width"
                                                onDemandData={true}
                                                setResults={setRearTireWidthResults}
                                                results={rearTireWidthResults}
                                                fetchData={rearTireWidthFetchData}
                                                setSearchQuery={setRearTireWidthSearchQuery}
                                                searchQuery={rearTireWidthSearchQuery}
                                                initialLoading={rearTireWidthInitialLoading}
                                                loadingMore={rearTireWidthLoadingMore}
                                                page={rearTireWidthPage}
                                                setPage={setRearTireWidthPage}
                                                hasMore={rearTireWidthHasMore}
                                                setHasMore={setRearTireWidthHasMore}
                                            />

                                            <CustomSearchableDropdown
                                                label="Ratio"
                                                selectedOptionLabel={rearTireRatioLabel}
                                                setSelectedOptionLabel={setRearTireRatioLabel}
                                                placeholder="Search Ratio"
                                                onDemandData={true}
                                                setResults={setRearTireRatioResults}
                                                results={rearTireRatioResults}
                                                fetchData={rearTireRatioFetchData}
                                                setSearchQuery={setRearTireRatioSearchQuery}
                                                searchQuery={rearTireRatioSearchQuery}
                                                initialLoading={rearTireRatioInitialLoading}
                                                loadingMore={rearTireRatioLoadingMore}
                                                page={rearTireRatioPage}
                                                setPage={setRearTireRatioPage}
                                                hasMore={rearTireRatioHasMore}
                                                setHasMore={setRearTireRatioHasMore}
                                            />

                                            <CustomSearchableDropdown
                                                label="Diameter"
                                                value={rearTireSizeId}
                                                setValue={setRearTireSizeId}
                                                selectedOptionLabel={rearTireDiameterLabel}
                                                setSelectedOptionLabel={setRearTireDiameterLabel}
                                                placeholder="Search Diameter"
                                                onDemandData={true}
                                                setResults={setRearTireDiameterResults}
                                                results={rearTireDiameterResults}
                                                fetchData={rearTireDiameterFetchData}
                                                setSearchQuery={setRearTireDiameterSearchQuery}
                                                searchQuery={rearTireDiameterSearchQuery}
                                                initialLoading={rearTireDiameterInitialLoading}
                                                loadingMore={rearTireDiameterLoadingMore}
                                                page={rearTireDiameterPage}
                                                setPage={setRearTireDiameterPage}
                                                hasMore={rearTireDiameterHasMore}
                                                setHasMore={setRearTireDiameterHasMore}
                                            />
                                        </div>

                                        <div className={`flex items-center justify-between mt-2`}>
                                            <span onClick={() => {
                                                setIsRearTireSize(false)
                                            }} className="text-xs underline hover:cursor-pointer text-blue-600">Remove</span>

                                            <span onClick={() => {
                                                setShowTireSizeHelpPopup(true)
                                            }} className="text-xs underline hover:cursor-pointer text-blue-600">Need help finding tire size?</span>
                                        </div>
                                    </div>

                                </>
                            )
                        }


                        {
                            (((modelId !== null && modelId > 0) || isCantFindIt) && isRequestedTireSize && (serviceType === "Tire" || serviceType === "Wheel")) && (
                                <>
                                    <div className={`flex items-center`}>
                                        <h2 className="text-lg font-semibold text-gray-800">
                                            Enter Requested Tire Size
                                        </h2>
                                    </div>

                                    <div className="border-b pb-4 relative">
                                        <p className="text-center text-sm font-semibold">
                                            Find your tire size inside of vehicle's driver front door jamb
                                        </p>
                                        <div className="flex items-center justify-center">
                                            <img
                                                src="/images/tiresizehelp2.png"
                                                alt="Tire size example"
                                                className="rounded w-[320px]"
                                            />
                                        </div>
                                        <div className="grid grid-cols-3 gap-3 pb-4 relative">
                                            <div>
                                                <span className="text-sm text-gray-700">Width*</span>
                                                <div className={`border border-gray-300 rounded-xl p-[5px] text-sm bg-white`}>
                                                    <input
                                                        type="text"
                                                        placeholder="Width"
                                                        className="w-full outline-none p-2 "
                                                        value={requestedTireWidth}
                                                        onChange={(e) => {
                                                            setRequestedTireWidth(e.target.value)
                                                        }}


                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <span className="text-sm text-gray-700">Ratio*</span>
                                                <div className={`border border-gray-300 rounded-xl p-[5px] text-sm bg-white`}>
                                                    <input
                                                        type="text"
                                                        placeholder="Ratio"
                                                        className="w-full outline-none p-2 "
                                                        value={requestedTireRatio}
                                                        onChange={(e) => {
                                                            setRequestedTireRatio(e.target.value)
                                                        }}


                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <span className="text-sm text-gray-700">Diameter*</span>
                                                <div className={`border border-gray-300 rounded-xl p-[5px] text-sm bg-white`}>
                                                    <input
                                                        type="text"
                                                        placeholder="Diameter"
                                                        className="w-full outline-none p-2 "
                                                        value={requestedTireDiameter}
                                                        onChange={(e) => {
                                                            setRequestedTireDiameter(e.target.value)
                                                        }}


                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`flex items-center justify-between mt-2`}>
                                            <span onClick={() => {
                                                setIsRequestedTireSize(false)
                                            }} className="text-xs underline hover:cursor-pointer text-blue-600">Remove</span>

                                            <span onClick={() => {
                                                setShowTireSizeHelpPopup(true)
                                            }} className="text-xs underline hover:cursor-pointer text-blue-600">Need help finding tire size?</span>
                                        </div>
                                    </div>

                                </>
                            )
                        }


                        {
                            (tireSizeId > 0 && (serviceType === "Tire" || serviceType === "Wheel")) && (
                                <div className="border-b pb-4 relative">
                                    <label className="flex items-center gap-2 cursor-pointer select-none">
                                        <input
                                            type="checkbox"
                                            className="h-4 w-4 cursor-pointer"
                                            checked={isCommercial}
                                            onChange={(e) => setIsCommercial(e.target.checked)}
                                        />
                                        <span className="text-sm font-medium text-gray-700">
                                            Is Commercial?
                                        </span>
                                    </label>
                                </div>

                            )
                        }


                        <div className="border-b pb-4 space-y-3">
                            <h2 className="text-lg font-semibold text-gray-800">
                                Service Details
                            </h2>
                            {
                                blockDaysCheckWarning && (
                                    <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                        {blockDaysCheckWarning}
                                    </p>
                                )
                            }
                            <div
                                className={`grid grid-cols-1 gap-4 ${isRequireTireCount ? "md:grid-cols-3" : "md:grid-cols-2"
                                    }`}
                            >
                                {isRequireTireCount && (
                                    <div>
                                        <label className="text-sm font-medium text-gray-700 block mb-1">
                                            {serviceType} Count*
                                        </label>
                                        <select
                                            value={tireCount}
                                            onChange={(e) => setTireCount(Number(e.target.value))}
                                            className="w-full border border-gray-300 rounded-xl px-3 py-4 text-sm outline-none focus:border-primary bg-white"
                                        >
                                            {Array.from({ length: 5 }, (_, i) => i + 1).map((count) => (
                                                <option key={count} value={count}>
                                                    {count}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {/* Date */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-1">
                                        Appointment Date*
                                    </label>
                                    <CustomDateField
                                        value={selectedDate}
                                        onChange={(value) => { setSelectedDate(value) }}
                                        minDate={new Date().toISOString().split("T")[0]}
                                        className="w-full border border-gray-300 rounded-xl px-3 py-4 text-sm outline-none focus:border-primary"
                                        required={true}
                                    />

                                </div>

                                {/* Time */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-1">
                                        Appointment Time*
                                    </label>
                                    <input
                                        type="time"
                                        className="w-full border border-gray-300 rounded-xl px-3 py-[15px] text-sm outline-none focus:border-primary"
                                        value={selectedTime}
                                        onChange={(e) => setSelectedTime(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                        </div>



                        {/* Section Title */}
                        <h2 className="text-lg font-semibold text-gray-800">
                            Personal Details
                        </h2>

                        {/* Form Grid */}
                        <form className="space-y-4" onSubmit={handleSubmit}>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-1">
                                        First Name*
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter first name"
                                        className="w-full border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary"
                                        required
                                        value={firstName}
                                        onChange={(e) => { setFirstName(e.target.value) }}
                                    />
                                </div>

                                {/* Last Name */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 block mb-1">
                                        Last Name*
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter last name"
                                        className="w-full border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary"
                                        required
                                        value={lastName}
                                        onChange={(e) => { setLastName(e.target.value) }}
                                    />
                                </div>
                            </div>



                            {/* Email */}
                            <div>
                                <label className="text-sm font-medium text-gray-700 block mb-1">
                                    Email*
                                </label>
                                <input
                                    type="email"
                                    placeholder="Enter email address"
                                    className="w-full border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary"
                                    required
                                    value={email}
                                    onChange={handleEmailChange}
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700 block mb-1">
                                    Phone Number*
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter phone number"
                                    className="w-full border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary"
                                    required
                                    value={formatUSPhone(phoneNumber)}
                                    pattern="\(\d{3}\) \d{3}-\d{4}"
                                    onChange={(e) => {
                                        const digits = getUSPhoneDigits(e.target.value);
                                        setPhoneNumber(digits);
                                    }}
                                />
                            </div>

                            {/* Extra Information (Optional) */}
                            <div>
                                <label className="text-sm font-medium text-gray-700 block mb-1">
                                    Additional Information (Optional)
                                </label>
                                <textarea
                                    rows={4}
                                    placeholder="Add any extra details about your service request..."
                                    className="w-full border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary"
                                    value={additionalInfo}
                                    onChange={(e) => { setAdditionalInfo(e.target.value) }}
                                />
                            </div>
                            <button type="submit" className="w-full bg-primary hover:bg-orange-600 text-white text-lg py-3 rounded-[70px] font-medium transition">
                                Confirm Service
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={showPleasewait} />
            <TireSizeHelpPopup showPopup={showTireSizeHelpPopup} setShowPopup={setShowTireSizeHelpPopup} />
        </>

    )
}